import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { OrdersRoomPage } from '../../../orders/orders-rooms/orders-rooms';
import { HomePage } from '../../../home/home';

@Component({
  selector: 'page-tutorial-order',
  templateUrl: 'tutorial-order.html',
})
export class TutorialOrderPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    if (this.globals.checkLimitsByLicense('tpv', 'comandero')) {
      this.globals.side_menu_active = 'order';
      this.globals.side_menu_active_analytics = false;
      this.navCtrl.setRoot(OrdersRoomPage);
    } else {
      this.navCtrl.push(HomePage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-order/tutorial-order.ts